import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';


export default createStore({
    plugins: [createPersistedState()],
    state: {
        openSidebarPrimary: false,
        hoverSidebarPrimary: false,
        token: null,
        refreshToken: null,
        user: null,
        isVisibleSideBarGenericModal: false,
        fieldsModalGeneric: [],
        currentCrew: null,
        currentRunIa: null,
        userInfoData: null,
        crewsList: [],
        currentCrewHistory: null,
        ordersHistory: [],
        orderByCrewsHistory: [],
        favoriteOrdersHistory: [],
        /** Dados da instituição para comunicações e contexto dos agentes (persistido). */
        companyProfile: {
            logoDataUrl: '',
            companyName: '',
            email: '',
            phone: '',
            website: '',
            address: '',
            extraContacts: ''
        },
        /** Módulos do marketplace mock ativados na conta (ids de marketplaceMock). */
        marketplaceAttachedTemplateIds: []
    },
    getters: {
        companyContextForAgents(state) {
            const c = state.companyProfile || {};
            const lines = [];
            if (c.companyName) lines.push(`Instituição: ${c.companyName}`);
            if (c.email) lines.push(`E-mail: ${c.email}`);
            if (c.phone) lines.push(`Telefone: ${c.phone}`);
            if (c.website) lines.push(`Site: ${c.website}`);
            if (c.address) lines.push(`Endereço: ${c.address}`);
            if (c.extraContacts) lines.push(`Outros contatos:\n${c.extraContacts}`);
            return lines.join('\n');
        }
    },
    mutations: {
        setOpenSidebarPrimary(state, isOpen) {
            state.openSidebarPrimary = isOpen;
        },
        setHoverSidebarPrimary(state, isHover) {
            state.hoverSidebarPrimary = isHover;
        },
        setToken(state, token) {
            state.token = token;
            if (token == null) {
                try {
                    sessionStorage.removeItem('ea-chat-thread-cache');
                } catch (e) {
                    /* ignore */
                }
            }
        },
        setRefreshToken(state, refreshToken) {
            state.refreshToken = refreshToken;
        },
        setUser(state, user) {
            state.user = user;
        },
        setIsVisibleSideBarGenericModal(state, isVisibleSideBarGenericModal) {
            state.isVisibleSideBarGenericModal = isVisibleSideBarGenericModal;
        },
        setFieldsModalGeneric(state, fields) {
            state.fieldsModalGeneric = fields;
        },
        setCurrentCrew(state, currentCrew) {
            state.currentCrew = currentCrew;
        },
        setCurrentRunIa(state, currentRunIa) {
            state.currentRunIa = currentRunIa;
        },
        setUserInfoData(state, userInfoData) {
            state.userInfoData = userInfoData;
        },
        setCrewsList(state, crewsList) {
            state.crewsList = crewsList;
        },
        setCurrentCrewHistory(state, currentCrewHistory) {
            state.currentCrewHistory = currentCrewHistory;
        },
        setOrdersHistory(state, ordersHistory) {
            state.ordersHistory = ordersHistory;
        },
        setOrderByCrewsHistory(state, orderByCrewsHistory) {
            state.orderByCrewsHistory = orderByCrewsHistory;
        },
        setFavoriteOrdersHistory(state, favoriteOrdersHistory) {
            state.favoriteOrdersHistory = favoriteOrdersHistory;
        },
        setCompanyProfile(state, profile) {
            state.companyProfile = { ...state.companyProfile, ...profile };
        },
        setMarketplaceAttachedTemplateIds(state, ids) {
            state.marketplaceAttachedTemplateIds = Array.isArray(ids) ? [...ids] : [];
        },
        toggleMarketplaceTemplate(state, templateId) {
            const cur = state.marketplaceAttachedTemplateIds || [];
            const set = new Set(cur);
            if (set.has(templateId)) set.delete(templateId);
            else set.add(templateId);
            state.marketplaceAttachedTemplateIds = [...set];
        }
    },
    actions: {
        storeSidebarPrimary({ commit }, payload) {
            commit('setOpenSidebarPrimary', payload.openSidebarPrimary);
        },
        storeHoverSidebarPrimary({ commit }, payload) {
            commit('setHoverSidebarPrimary', payload.hoverSidebarPrimary);
        },
        storeToken({ commit }, payload) {
            commit('setToken', payload.token);
        },
        storeRefreshToken({ commit }, payload) {
            commit('setRefreshToken', payload.refreshToken);
        },
        storeUser({ commit }, payload) {
            commit('setUser', payload.user);
        },
        storeIsVisibleSideBarGenericModal({ commit }, payload) {
            commit('setIsVisibleSideBarGenericModal', payload.isVisibleSideBarGenericModal);
        },
        storeFieldsModalGeneric({ commit }, payload) {
            commit('setFieldsModalGeneric', payload.fields);
        },
        storeCurrentCrew({ commit }, payload) {
            commit('setCurrentCrew', payload.currentCrew);
        },
        storeCurrentRunIa({ commit }, payload) {
            commit('setCurrentRunIa', payload.currentRunIa);
        },
        storeUserInfoData({ commit }, payload) {
            commit('setUserInfoData', payload.userInfoData);
        },
        storeCrewsList({ commit }, payload) {
            commit('setCrewsList', payload.crewsList);
        },
        storeCurrentCrewHistory({ commit }, payload) {
            commit('setCurrentCrewHistory', payload.currentCrewHistory);
        },
        storeOrdersHistory({ commit }, payload) {
            commit('setOrdersHistory', payload.ordersHistory);
        },
        storeOrderByCrewsHistory({ commit }, payload) {
            commit('setOrderByCrewsHistory', payload.orderByCrewsHistory);
        },
        storeFavoriteOrdersHistory({ commit }, payload) {
            commit('setFavoriteOrdersHistory', payload.favoriteOrdersHistory);
        },
        storeCompanyProfile({ commit }, payload) {
            commit('setCompanyProfile', payload.companyProfile);
        },
        storeMarketplaceAttachedTemplateIds({ commit }, payload) {
            commit('setMarketplaceAttachedTemplateIds', payload.templateIds);
        },
        storeMarketplaceToggleTemplate({ commit }, payload) {
            commit('toggleMarketplaceTemplate', payload.templateId);
        }
    }
});
